import { useEffect } from 'react';
import OktaSignIn from '@okta/okta-signin-widget';
import '@okta/okta-signin-widget/css/okta-sign-in.min.css';
import 'components/Login/LoginWidget.css';
import Logger from 'utilities/logger';
import * as OktaConfig from 'constants/config/okta';

const useOktaWidget = () => {
  const logger = Logger('useOktaWidget');
  const signIn = new OktaSignIn(OktaConfig.getOktaConfig());

  useEffect(() => {
    signIn.showSignInAndRedirect({ el: '#sign-in-widget' }).catch(err => {
      // This function is invoked with errors the widget cannot recover from:
      // Known errors: CONFIG_ERROR, UNSUPPORTED_BROWSER_ERROR
      console.error(err);
    });
    return () => {
      try {
        signIn && signIn.remove();
      } catch (err) {
        logger.error(err);
      }
    };
  }, []);
};

export default useOktaWidget;
